import Seo from "@/components/Seo";
import useCurrentState from "@/routes/useCurrentState";
import { statePath } from "@/lib/stateRegistry";

/**
 * PLACEHOLDER. Commercial quote intake is launch-blocking for Texas (Product Contract 2)
 * but not built yet (needs backend commercial_quote_requests). This page must never show
 * a rate figure: commercial pricing exists only as a real quote returned to a real
 * requester (Contract 2; acceptance criterion 18).
 */
export default function CommercialIntake() {
  const state = useCurrentState();
  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-16" data-testid="commercial-page" data-state={state.slug}>
      <Seo title={`${state.name} business energy quotes`} path={statePath(state.slug, "commercial")} noindex />
      <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-[#0A2540]">Business energy quotes in {state.name}</h1>
      <p className="mt-4 text-lg text-slate-600 max-w-[60ch]">
        The quote request form is not open yet. We are not accepting business requests through this page today.
      </p>
    </div>
  );
}
